var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"result"},[_c('div',{staticClass:"btns"},[(_vm.copyable)?_c('ui-raised-button',{staticClass:"btn btn-copy",attrs:{"label":"复制"}}):_vm._e()],1),_vm._v(" "),_c('pre',{staticClass:"content"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-59810c7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/result/page.vue
// module id = null
// module chunks = 